import React from 'react';
import PropTypes from 'prop-types';

import { TextField } from '@material-ui/core';
import { DatePicker } from '@mui/x-date-pickers';
import moment from 'moment';

const DATE_FORMAT = 'YYYY-MM-DD';

const RenderDateField = ({ meta, input, autocomplete, ...props }) => (
  <DatePicker
    value={moment(input.value, DATE_FORMAT)}
    onChange={v => input.onChange(moment(v).format(DATE_FORMAT))}
    slots={{ textField: TextField }}
    slotProps={{
      textField: {
        input,
        autocomplete,
        meta,
        error: meta.error && meta.touched,
        ...props,
      },
    }}
  />
);

RenderDateField.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.string,
  type: PropTypes.string,
  meta: PropTypes.object,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  autocomplete: PropTypes.string,
  props: PropTypes.object,
};

RenderDateField.defaultProps = {
  disabled: false,
  placeholder: '',
  label: '',
  type: 'text',
  autocomplete: null,
  meta: {},
  props: {},
};

export default RenderDateField;
